import { MileageCostOptionsSlideOut, useCustomMileageNumericField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { OutOfFlowHost } from '../../../ScenarioGrid.style';
import { ScenarioRow } from '../../ScenarioRow';
import { MileageOptionsLabel } from './MileageOptionsLabel';

export const CustomMileageNumericRow = () => {
    const { label, isLocked, hasOptions, isSlideOutOpen, toggleSlideOut, inputProps } = useCustomMileageNumericField();
    const inputId = useScenarioCellId('annualMiles');

    return (
        <ScenarioRow
            rowKey="annualMiles"
            label={
                <MileageOptionsLabel
                    label={label}
                    inputId={inputId}
                    hasOptions={hasOptions}
                    isLocked={isLocked}
                    onOptionsActivate={toggleSlideOut}
                />
            }
        >
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
            {isSlideOutOpen && (
                <OutOfFlowHost>
                    <MileageCostOptionsSlideOut show={isSlideOutOpen} onHide={toggleSlideOut} />
                </OutOfFlowHost>
            )}
        </ScenarioRow>
    );
};
